import { c as _c } from "react/compiler-runtime";
import React, { CurrencyEnum, FieldErrorAndDescription, FormSelect, Hint, PaymentMethodEnum } from '@systemeio/ui';
import { usePaymentMethods } from 'modules/payment-methods/hooks/use-payment-methods';
import { EditableItemType } from 'shared/components/edit-modal';
import { useCurrencyData } from 'shared/hooks/use-currency-data';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import PaymentMethods from '../../modules/payment-methods/components/payment-methods';
import { useCurrency } from '../../modules/payment-methods/hooks/use-currency';
export const usePaymentMethodsByCurrency = t0 => {
  const $ = _c(27);
  const {
    currency,
    errors,
    currencyChangeMessage,
    allowedPaymentMethods: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? Object.values(PaymentMethodEnum) : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const allowedPaymentMethods = t2;
  const {
    t
  } = useLocoTranslation();
  const currencyData = useCurrencyData();
  let t3;
  if ($[2] !== currency || $[3] !== currencyChangeMessage) {
    t3 = {
      initCurrency: currency,
      currencyChangeMessage
    };
    $[2] = currency;
    $[3] = currencyChangeMessage;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    currentCurrency,
    setCurrentCurrency,
    showToast
  } = useCurrency(t3);
  const {
    data: paymentMethodsData
  } = usePaymentMethods(currentCurrency);
  const isReady = !!paymentMethodsData;
  let t4;
  if ($[5] !== currencyChangeMessage || $[6] !== currencyData || $[7] !== errors || $[8] !== setCurrentCurrency || $[9] !== showToast || $[10] !== t) {
    t4 = {
      field: "currency",
      onRender: (value, _, state, __, isPreFetching, onChangeState) => <FormSelect withoutCloseIcon={true} key="currency-edit" placeholder={t("global.currency")} label={<Hint label={currencyChangeMessage}>{t("global.currency")}</Hint>} data={currencyData} value={value as T['currency']} onChange={data => {
        onChangeState({
          ...state,
          currency: data,
          paymentMethods: []
        });
        setCurrentCurrency(data);
        showToast();
      }} isPreFetching={isPreFetching} error={errors.currency} />
    };
    $[5] = currencyChangeMessage;
    $[6] = currencyData;
    $[7] = errors;
    $[8] = setCurrentCurrency;
    $[9] = showToast;
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== allowedPaymentMethods || $[13] !== errors || $[14] !== paymentMethodsData?.paymentMethods) {
    t5 = (value_0, onChange, __0, ___0, isPreFetching_0) => <div className="flex flex-col gap-2"><PaymentMethods isPreFetching={isPreFetching_0} key="payment-methods-edit" data={paymentMethodsData?.paymentMethods.filter(pm => allowedPaymentMethods.includes(pm))} value={(value_0 ?? []) as T['paymentMethods']} onChange={onChange as (value_0: T['paymentMethods']) => void} />{errors && errors.paymentMethods && <FieldErrorAndDescription error={errors.paymentMethods} />}</div>;
    $[12] = allowedPaymentMethods;
    $[13] = errors;
    $[14] = paymentMethodsData?.paymentMethods;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== errors) {
    t6 = state_0 => !!state_0.currency || !!errors.paymentMethods;
    $[16] = errors;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = {
      field: "paymentMethods",
      onRender: t5,
      shouldRender: t6
    };
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t4 || $[22] !== t7) {
    t8 = [t4, t7];
    $[21] = t4;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const currencyAndPaymentMethodsEditFields = t8 as const;
  let t9;
  if ($[24] !== currencyAndPaymentMethodsEditFields || $[25] !== isReady) {
    t9 = {
      currencyAndPaymentMethodsEditFields,
      isReady
    };
    $[24] = currencyAndPaymentMethodsEditFields;
    $[25] = isReady;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};